/**
 * Kiosk Offline Kuyruğu — IndexedDB tabanlı.
 *
 * Her /terminal/stamp çağrısı önce online denenir, ağ hatasında kuyruğa
 * eklenir. `client_id` benzersizdir → sunucu duplicate önler.
 *
 * Kayıt şeması: {client_id, employee_id, method, confidence, local_ts, attempts, last_error}
 */
const DB_NAME = "fucan_pdks_kiosk";
const DB_VERSION = 1;
const STORE = "pending_stamps";

function open() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "client_id" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(mode, fn) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const store = t.objectStore(STORE);
    const result = fn(store);
    t.oncomplete = () => resolve(result);
    t.onerror = () => reject(t.error);
    t.onabort = () => reject(t.error);
  });
}

function uuid() {
  if (crypto?.randomUUID) return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 3) | 8).toString(16);
  });
}

export async function enqueueStamp({ employee_id, method, confidence, local_ts }) {
  const doc = {
    client_id: uuid(),
    employee_id, method, confidence, local_ts,
    attempts: 0, last_error: null,
    created_at: new Date().toISOString(),
  };
  await tx("readwrite", (s) => s.add(doc));
  return doc;
}

export async function listPending() {
  return tx("readonly", (s) => new Promise((resolve) => {
    const items = [];
    const cursorReq = s.openCursor();
    cursorReq.onsuccess = (e) => {
      const c = e.target.result;
      if (c) { items.push(c.value); c.continue(); }
      else resolve(items);
    };
  }));
}

export async function removePending(client_id) {
  return tx("readwrite", (s) => s.delete(client_id));
}

export async function markAttempt(client_id, err) {
  return tx("readwrite", (s) => {
    const g = s.get(client_id);
    g.onsuccess = () => {
      const v = g.result;
      if (!v) return;
      v.attempts = (v.attempts || 0) + 1;
      v.last_error = err ? String(err).slice(0, 200) : null;
      s.put(v);
    };
  });
}

export async function pendingCount() {
  const items = await listPending();
  return items.length;
}
